//@ts-nocheck
import React, { useState, useEffect, useRef } from 'react'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'
import { compose } from 'redux'
import styles from './nav.module.scss'
import NavItem from './navItems/navItem'
import basket from '../../assets/basket.png'
import BasketItem from './basketItem/basketItem'
import { keyGenerator } from '../../helpers/helpers'
import Hamburger from 'hamburger-react'
import MobileNavItem from './mobileNavitem/mobileNavItem'
import withRouter from '../../hooks/withRouter'
import { RootState } from '../../redux/store'
import { Words } from '../../types/lang'
import {
  getChildrenItems,
  getEducationalItems,
  getImaginativeItems,
  getItAndProgrammingItems,
  getOthersItems,
} from '../../config/navItems'
import { BasketBook, Book } from '../../types/book'
import {
  addBookToBasket,
  loadBasketBooks,
  setBooksToBasket,
} from '../../redux/book.slice'
import { AuthUser } from '../../types/user'
import { getBooksFromLocalBasket } from '../../utils/book/getBooksFromLocalBasket'
import { resetLocalBasketBooks } from '../../utils/book/resetLocalBasketBooks'

interface NavBarProps {
  words: Words
  basketBooks: BasketBook[]
  authUser: AuthUser
  loadBasketBooks: () => void
  setBooksToBasket: (basketBooks: BasketBook[]) => void
  addBookToBasket: (bookId: string) => void
}

const NavBar = (props: NavBarProps) => {
  const {
    words,
    authUser,
    basketBooks,
    loadBasketBooks,
    setBooksToBasket,
    addBookToBasket,
  } = props
  const [count, setCount] = useState(0)
  const [price, setPrice] = useState(0)
  const [scrollY, setScrollY] = useState(0)
  const [isBasketPanel, setIsBasketPanel] = useState(true)
  const navRef = useRef(0)
  const baketPanelRef = useRef('')
  const [isOpen, setIsOpen] = useState(false)
  const menuRef = useRef('')

  const getScrollY = () => {
    setScrollY(window.scrollY)
  }

  const addBooksFromLocalToServer = async (books: BasketBook[]) => {
    for await (const book of books) {
      await addBookToBasket(book.book.id)
    }
  }

  useEffect(() => {
    window.addEventListener('scroll', getScrollY)

    return () => {
      window.removeEventListener('scroll', getScrollY)
    }
  }, [])

  useEffect(() => {
    if (authUser) {
      const basketBooksFromLocalStorage = getBooksFromLocalBasket()
      addBooksFromLocalToServer(basketBooksFromLocalStorage)
      resetLocalBasketBooks()
      loadBasketBooks()
    } else {
      const basketBooksFromLocalStorage = getBooksFromLocalBasket()
      setBooksToBasket(basketBooksFromLocalStorage)
    }

    return () => {
      window.removeEventListener('scroll', getScrollY)
    }
  }, [authUser])

  useEffect(() => {
    if (scrollY > 176) {
      navRef.current.style.position = 'fixed'
      navRef.current.style.top = 0
    } else {
      navRef.current.style.position = 'relative'
    }
  }, [scrollY])

  useEffect(() => {
    if (basketBooks?.length > 0) {
      const totalCount = basketBooks.reduce(
        (total, book) => total + book.count,
        0,
      )
      setCount(totalCount)
      const totalPrice = basketBooks.reduce((total, book) => {
        return total + book.book.price * book.count
      }, 0)
      setPrice(Math.floor(totalPrice * 100) / 100)
    }
    if (basketBooks?.length === 0) {
      setCount(0)
      setPrice(0)
    }
  }, [basketBooks])

  const setDisplayNone = () => {
    const classList = baketPanelRef.current.className.split(' ')
    baketPanelRef.current.className = classList[0]
    setTimeout(() => {
      baketPanelRef.current.className = classList
        .toString()
        .replaceAll(',', ' ')
    }, 500)
  }

  const imaginative = getImaginativeItems(words)
  const educational = getEducationalItems(words)
  const children = getChildrenItems(words)
  const itAndProgramming = getItAndProgrammingItems()
  const others = getOthersItems(words)

  const menuClickHandler = (value) => {
    setIsOpen(value)
    const menu = menuRef.current
    if (value) {
      document.body.style.overflow = 'hidden'
      navRef.current.style.zIndex = 3500
      menu.style.left = '0'
      menu.style.transition = 'left 0.5s'
    } else {
      document.body.style.overflow = 'scroll'
      menu.style.left = '-100vw'
      menu.style.transition = 'left 0.5s'
      setTimeout(() => {
        navRef.current.style.zIndex = 2000
      }, 600)
    }
  }

  return (
    <div className={styles.container} ref={navRef}>
      <div className={styles.burgerMenu}>
        <Hamburger size={20} toggled={isOpen} toggle={menuClickHandler} />
      </div>
      <div className={styles.navContainer}>
        <NavItem
          className={styles.nav}
          title={words.imaginative}
          items={imaginative}
          to="/books/categories/imaginative"
        />
        <NavItem
          className={styles.nav}
          title={words.educational}
          items={educational}
          to="/books/categories/educational"
        />
        <NavItem
          className={styles.nav}
          title={words.children}
          items={children}
          to="/books/categories/children"
        />
        <NavItem
          className={styles.nav}
          title={words.it_and_programing}
          items={itAndProgramming}
          to="/books/categories/it_and_programing"
        />
        <NavItem
          className={styles.navItem}
          title={words.others}
          items={others}
          to="/books/categories/other"
        />
      </div>

      <div className={styles.basketContainer}>
        <NavLink to="/basket">
          <img src={basket} alt="" />
        </NavLink>
        <div className={styles.mobBooksCount}>{count}</div>
        <div
          onClick={() => setIsBasketPanel(!isBasketPanel)}
          className={styles.info}
        >
          <div className={styles.basketInfo}>{`${words.count}: ${count}`}</div>
          <div
            className={styles.basketInfo}
          >{`${words.price}: ${price} €`}</div>
          <div className={`${styles.triangle} ${styles.triangleShow}`}></div>
          <div
            ref={baketPanelRef}
            id={styles.basketPanel}
            className={`${styles.basketPanel} ${styles.basketPanelShow}`}
          >
            <div className={styles.itemContainer}>
              {basketBooks?.length > 0 &&
                basketBooks.map((book: any, i: number) => {
                  return (
                    //@ts-ignore
                    <BasketItem
                      key={`${i}cons${book.idid}`}
                      name={book.book.name}
                      count={book.count}
                      price={book.book.price}
                      id={book.book._id}
                    />
                  )
                })}
            </div>
            <div className={styles.totalPrice}>
              {words.totalPrice}: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{price}
              &nbsp;€
            </div>
            <div className={styles.btnContainer}>
              {/* <NavLink onClick={setDisplayNone} ref={buyButton}  to={'/buy'} className={styles.btn}>{words.buy}</NavLink> */}
              <NavLink
                onClick={setDisplayNone}
                to={'/basket'}
                className={styles.btn}
              >
                {words.basket}
              </NavLink>
            </div>
          </div>
        </div>
      </div>
      <div ref={menuRef} className={styles.menuContainer}>
        <div className={styles.menu}>
          <div className={styles.closeContainer}>
            <i
              onClick={() => menuClickHandler(false)}
              className="fas fa-times"
            ></i>
          </div>
          <MobileNavItem
            mainName={words.imaginative}
            mainRout="/books/categories/imaginative"
            iconFont="fas fa-book"
            items={imaginative}
            onClick={() => menuClickHandler(false)}
          />
          <MobileNavItem
            mainName={words.educational}
            mainRout="/books/categories/educational"
            iconFont="fas fa-user-graduate"
            items={educational}
            onClick={() => menuClickHandler(false)}
          />
          <MobileNavItem
            mainName={words.children}
            mainRout="/books/categories/children"
            iconFont="fas fa-child"
            items={children}
            onClick={() => menuClickHandler(false)}
          />
          <MobileNavItem
            mainName={words.it_and_programing}
            mainRout="/books/categories/it_and_programing"
            iconFont="fas fa-laptop-code"
            items={itAndProgramming}
            onClick={() => menuClickHandler(false)}
          />
          <MobileNavItem
            mainName={words.others}
            mainRout="/books/categories/other"
            iconFont="fas fa-book-reader"
            items={others}
            onClick={() => menuClickHandler(false)}
          />
        </div>
        <div
          onClick={() => menuClickHandler(false)}
          className={styles.sideBar}
        ></div>
      </div>
    </div>
  )
}

let mapStateToProps = (state: RootState) => {
  return {
    words: state.main.words,
    price: state.main.price,
    count: state.main.count,
    basketBooks: state.book.basketBooks,
    authUser: state.user.authUser,
  }
}

export default connect(mapStateToProps, {
  loadBasketBooks,
  setBooksToBasket,
  addBookToBasket,
})(NavBar)
